<script>
import mixins from '../apimixins'
import moment from 'moment'
import Parameters from './parameters'
import TablePaginator from '@components/paginator'
import api from '@utils/api'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'OilUsageDuringATimePeriodByOilType',
  components: {
    AdjustColumnsDialog,
    Parameters,
    TablePaginator,
  },
  mixins: [mixins],
  data() {
    return {
      modelName: 'OilUsageDuringATimePeriodByOilType',
      firstRun: true,
      showDialog: false,
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        {
          text: 'customer',
          value: 'customerNumber',
          sortable: true,
          show: true,
        },
        { text: 'oil_type', value: 'oil', sortable: true, show: true },
        { text: 'article', value: 'articleName', sortable: true },
        { text: 'oil_usage', value: 'amount', sortable: true },
      ],
    }
  },
  methods: {
    setParams(value) {
      this.otherParams = { ...value }
      this.resetPage()
      this.init()
    },
    async init() {
      this.getPaginator()
      let filters = this.getFilters()
      if (!this.firstRun || this.filtersEmpty(filters)) {
        this.getDataSet()
        this.firstRun = false
      }
    },
    getDataSet() {
      this.loading = true
      this.prepareFilterParams()
      this.getAvgOilConsumption()
    },
    getAvgOilConsumption() {
      this.otherParams.start_date = moment(this.params.start_date).valueOf()
      this.otherParams.end_date = moment(this.params.end_date).valueOf()
      return api
        .getReportData('oil_consumption', this.params)
        .then(response => {
          this.setResponseParams(response)

          this.content = response.content.map(content => {
            const {
              organisation,
              customer,
              oil,
              articleName,
              goodsId,
              consumption,
            } = content
            return {
              organisation,
              customerNumber: customer,
              oil,
              goodsId,
              articleName: articleName,
              amount: consumption,
            }
          })
          this.loading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <parameters
      @set-params="setParams($event)"
    />
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <div>
      <v-data-table
        :headers="headers"
        :items="content"
        :pagination="pagination"
        :total-items="totalElements"
        :loading="loading"
        :class="$style.sdTable"
        hide-actions
      >
        <template
          slot="headers"
          slot-scope="props">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              :class="getSortClass(header)"
              :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
              @click="changeSort(header)"
            >
              <span> {{ $t(`label__${header.text}`) }} </span>
              <v-icon
                v-if="header.sortable"
                small>expand_less
              </v-icon>
            </th>
          </tr>
        </template>
        <v-progress-linear
          slot="progress"
          height="2"
          color="blue"
          background-color="#E0E0E0"
          indeterminate
        />
        <template
          slot="items"
          slot-scope="props"
        >
          <tr>
            <td>
              <router-link
                v-if="userAllowedToNavigate && props.item.organisation"
                :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
              </router-link>
              <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
              <span v-if="!props.item.organisation">{{ '-' }}</span>
            </td>
            <td v-if="!hideValues('customerNumber')">{{ props.item.customerNumber }}</td>
            <td v-if="!hideValues('oil')">{{ getValue('goods', props.item.oil) }}</td>
            <td>
              <router-link
                v-if="props.item.articleName && userAllowedToNavigate"
                :to="{name:'goodsItem', params: {goodsId: props.item.goodsId.toString()}}">
                {{ props.item.articleName }}
              </router-link>
              <span v-else>{{ props.item.articleName }}</span>
            </td>
            <td>{{ `${(props.item.amount / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          </tr>
        </template>
      </v-data-table>
      <table-paginator
        :page="page"
        :total-pages="totalPages"
        :first="first"
        :last="last"
        :rows-per-page="pagination.rowsPerPage"
        @change-page="changePage($event)"
        @change-rows-per-page="changeRowsPerPage($event)"/>
      <adjust-columns-dialog
        v-model="showDialog"
        :headers="headers.filter(h => h.show !== undefined)"
        :model-name="modelName"
        @columns-updated="updateColumns"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
